export const PWA_UPDATE_POLL_INTERVAL_MS = 60_000;
export const PWA_UPDATE_TOAST_THRESHOLD_MS = 10 * 60 * 1000;

export interface UpdateDecisionState {
  updateReady: boolean;
  panelOpen: boolean;
  stripeInFlight: boolean;
  msSinceUpdateReady: number | null;
  toastShown: boolean;
}

export type UpdateDecisionAction = 'reload' | 'show-toast' | 'wait';

export function decideUpdateAction(state: UpdateDecisionState): UpdateDecisionAction {
  if (!state.updateReady) {
    return 'wait';
  }

  if (!state.panelOpen) {
    return 'reload';
  }

  const elapsed = state.msSinceUpdateReady ?? 0;
  if (
    elapsed >= PWA_UPDATE_TOAST_THRESHOLD_MS &&
    !state.toastShown &&
    !state.stripeInFlight
  ) {
    return 'show-toast';
  }

  return 'wait';
}
